export default function updateBoundaryPosition(
  canvas,
  boundaryRect,
  originalImage
) {
  if (!boundaryRect || !originalImage) {
    console.error(
      'updateBoundaryPosition: no boundary rectangle or original image provided'
    );
    return;
  }

  const imgData = boundaryRect.imgData;
  if (!imgData) {
    return;
  }

  // Calculate image boundaries
  const imgLeft = Math.round(originalImage.left);
  const imgTop = Math.round(originalImage.top);
  const imgRight = Math.round(
    imgLeft + originalImage.width * originalImage.scaleX
  );
  const imgBottom = Math.round(
    imgTop + originalImage.height * originalImage.scaleY
  );

  // Calculate boundary box edges
  const boundLeft = Math.round(boundaryRect.left);
  const boundTop = Math.round(boundaryRect.top);
  const boundRight = Math.round(boundLeft + boundaryRect.getScaledWidth());
  const boundBottom = Math.round(boundTop + boundaryRect.getScaledHeight());

  // Ensure the boundary fully contains the image
  let adjustX = 0;
  let adjustY = 0;

  if (boundLeft > imgLeft) {
    adjustX = imgLeft - boundLeft;
  } else if (boundRight < imgRight) {
    adjustX = imgRight - boundRight;
  }

  if (boundTop > imgTop) {
    adjustY = imgTop - boundTop;
  } else if (boundBottom < imgBottom) {
    adjustY = imgBottom - boundBottom;
  }

  // Ensure the boundary stays within the canvas
  const canvasWidth = canvas.getWidth();
  const canvasHeight = canvas.getHeight();

  // Adjust for right edge if it exceeds canvas width
  if (boundRight + adjustX > canvasWidth) {
    adjustX = canvasWidth - boundRight;
  }

  // Adjust for left edge if it's less than 0
  if (boundLeft + adjustX < 0) {
    adjustX = -boundLeft;
  }

  // Adjust for bottom edge if it exceeds canvas height
  if (boundBottom + adjustY > canvasHeight) {
    adjustY = canvasHeight - boundBottom;
  }

  // Adjust for top edge if it's less than 0
  if (boundTop + adjustY < 0) {
    adjustY = -boundTop;
  }

  // Apply adjustments if needed
  if (adjustX !== 0 || adjustY !== 0) {
    boundaryRect.set({
      left: Math.round(boundaryRect.left + adjustX),
      top: Math.round(boundaryRect.top + adjustY),
    });
    canvas.renderAll();
  }
}
